import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportAccountComponentModel} from '../reportAccountComponent.model';
import {Injectable} from '@angular/core';
import {UserSummaryConverter} from '../../../../../account/modules/user/api/converter/userSummary.converter';
import {
    ReportComponentSummaryConverter
} from '../../../../report-component/api/entity/converter/reportComponentSummary.converter';

@Injectable()
export class ReportAccountComponentConverter extends HttpModelConverter<ReportAccountComponentModel> {

    constructor(private componentConverter: ReportComponentSummaryConverter) {
        super();
    }
    protected createInstance(): ReportAccountComponentModel {
        return new ReportAccountComponentModel();
    }

    protected enrichObject(result: ReportAccountComponentModel, src: ReportAccountComponentModel) {
        result.user = new UserSummaryConverter().convert(src.user);
        result.component = this.componentConverter.convert(src.component);
    }

}
